import { render, staticRenderFns } from "./synchronous.vue?vue&type=template&id=68d7f28c&"
import script from "./synchronous.vue?vue&type=script&lang=js&"
export * from "./synchronous.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports